{
  "onboarding": {
    "message": "مرحبا بكم في موقع تطبيق obytes"
  },
  "settings": {
    "about": "حول التطبيق ",
    "app_name": "اسم التطبيق",
    "arabic": "عربي",
    "english": "إنجليزي",
    "generale": "عام",
    "github": "جيثب",
    "language": "لغة",
    "links": "الروابط",
    "logout": "تسجيل خروج",
    "more": "أكثر",
    "privacy": "سياسة الخصوصية",
    "rate": "تقييم",
    "share": "شارك",
    "support": "الدعم",
    "support_us": "ادعمنا",
    "terms": "شروط الخدمة",
    "theme": {
      "dark": "مظلم",
      "light": "خفيفة",
      "system": "System",
      "title": "سمة"
    },
    "title": "إعدادات",
    "version": "إصدار",
    "website": "موقع الكتروني"
  },
  "welcome": "test arabic"
}
